import React, { useState, useEffect } from "react";
import styles from "./AddOutputModal.module.scss";
import { OutputValue } from "../types/types";
import { getImageUrl } from "../../../../../commons/assets_path";
import store from "../../../../../reducks/store/AppTrigger/store";
import axios from "axios";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
import { useTranslation } from "react-i18next";

type Props = {
  outputList: OutputValue[];
  serviceIconName: string;
  setEditOutput: React.Dispatch<React.SetStateAction<{ isEdit: boolean; index: number; output: OutputValue | null }>>;
};

export const AddOutputList = ({ outputList, serviceIconName, setEditOutput }: Props) => {
  const { t } = useTranslation();
  const [hover, setHover] = useState<{ isHover: boolean; index: number }>({ isHover: false, index: -1 });

  const calcMaxWidth = (output: OutputValue) => {
    const displayNameLength = output.display_name.length;
    const testValueLength = output.readonly_test_value.length;
    // max-widthの値を計算します。240px以下、100px以上に制限し、
    // displayNameとtestValueの文字数に基づいて適切な幅を設定します。
    // displayNameが長いほどmax-widthが大きくなり、testValueが長いほど小さくなります。
    return Math.min(240, Math.max(100, (displayNameLength / (displayNameLength + testValueLength)) * 240));
  };

  const scrollToEnd = () => {
    const addOutput = document.getElementById(`output_${outputList.length - 1}`);
    addOutput?.scrollIntoView({ behavior: "smooth", block: "end" });
  };

  const deleteOutput = (index: number) => () => {
    store.dispatch({ type: "DELETE", index });
  };

  useEffect(() => {
    scrollToEnd();
  }, [outputList.length]);

  return (
    <div className={styles.addOutputField}>
      <div className={styles.addOutputFieldTitle}>{t("AddOutputList.addedValue", { length: outputList.length })}</div>
      <div className={styles.addOutputFieldBody}>
        {outputList.map((output, index) => {
          return (
            <div
              id={`output_${index}`}
              key={index}
              className={styles.addOutputFieldItem}
              style={hover.isHover && hover.index === index ? { maxWidth: "330px" } : {}}
              onMouseEnter={() => setHover({ isHover: true, index })}
              onMouseLeave={() => setHover({ isHover: false, index: -1 })}
            >
              <img src={serviceIconName} width={20} height={20} />
              <div
                className={`${styles.addOutputFieldItemDisplayName} addOutputFieldItemDisplayName`}
                style={{ maxWidth: calcMaxWidth(output) }}
                title={output.display_name}
              >
                {output.display_name}
              </div>
              <div
                className={styles.addOutputFieldItemTestValue}
                style={{ maxWidth: calcMaxWidth(output) }}
                title={output.readonly_test_value}
              >
                {output.readonly_test_value}
              </div>
              {hover.isHover && hover.index === index && (
                <>
                  <img
                    className="test-edit_output_btn"
                    src={getImageUrl("images/icons/editGray.svg")}
                    style={{ cursor: "pointer" }}
                    onClick={() => setEditOutput({ isEdit: true, index, output })}
                  />
                  <img
                    src={getImageUrl("images/icons/close.svg")}
                    style={{ cursor: "pointer" }}
                    onClick={deleteOutput(index)}
                  />
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
